module.exports = __webpack_public_path__ + "static/vlad-light-2ad48791b539735e214886c78aeb0038.png";